import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  apiDeletePets,
  apiGetListPet,
  apiImportExcelFile,
  apiUpdateHistoryVaccine,
  apiUpdatePet,
} from "../../api/services";
import { Global } from "../../common/global";

const initialState = {
  isSuccess: false,
  loading: false,
  pagination: { perPage: Global.DEFAULT_PAGINATION },
  pets: [],
};

export const requestGetListPet = createAsyncThunk("/pets", async (params) => {
  const res = await apiGetListPet(params);
  return res.data;
});

export const requestUpdatePet = createAsyncThunk(
  "pets/update",
  async (params) => {
    const res = await apiUpdatePet(params);
    return res.data;
  }
);

export const requestUpdateHistoryVaccine = createAsyncThunk(
  "/pets/history",
  async (params) => {
    const res = await apiUpdateHistoryVaccine(params);
    return res.data;
  }
);

export const requestDeletePets = createAsyncThunk(
  "pets/delete",
  async (params) => {
    const res = await apiDeletePets(params);
    return res.data;
  }
);

export const requestImportFile = createAsyncThunk(
  "/import-file",
  async (file) => {
    const res = await apiImportExcelFile(file);
    return res.data;
  }
);

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setPaginationPerPage: (state, action) => {
      state.pagination = {
        ...state.pagination,
        perPage: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestGetListPet.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestGetListPet.fulfilled, (state, action) => {
        state.loading = false;
        const { error, data } = action.payload;
        if (!error) {
          const { content, numberOfElements, totalElements, number, size } =
            data;
          state.pets = content.map((i) => ({ ...i, key: i.id }));
          state.pagination = {
            ...state.pagination,
            perPage: size,
            currentPage: number + 1,
            total: totalElements,
            count: numberOfElements,
          };
          // state.pets = data;
        }
      })
      .addCase(requestGetListPet.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(requestImportFile.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(requestImportFile.fulfilled, (state, action) => {
        state.loading = false;
        state.isSuccess = true;
      })
      .addCase(requestImportFile.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(requestDeletePets.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(requestDeletePets.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(requestDeletePets.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(requestUpdatePet.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(requestUpdatePet.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(requestUpdatePet.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(requestUpdateHistoryVaccine.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(requestUpdateHistoryVaccine.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(requestUpdateHistoryVaccine.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const adminState = (state) => state.adminState;

export const { setPaginationPerPage } = adminSlice.actions;
export default adminSlice.reducer;
